import React, { useCallback, useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { XIcon } from 'lucide-react';
const buyers = [{
  name: 'Lucía M.',
  location: 'Buenos Aires',
  time: 'hace 2 minutos'
}, {
  name: 'Carlos R.',
  location: 'Córdoba',
  time: 'hace 5 minutos'
}, {
  name: 'Mariana S.',
  location: 'Rosario',
  time: 'hace 8 minutos'
}, {
  name: 'Diego F.',
  location: 'Mendoza',
  time: 'hace 3 minutos'
}, {
  name: 'Valeria P.',
  location: 'Tucumán',
  time: 'hace 7 minutos'
}, {
  name: 'Sebastián G.',
  location: 'La Plata',
  time: 'hace 1 minuto'
}, {
  name: 'Florencia T.',
  location: 'Salta',
  time: 'hace 4 minutos'
}, {
  name: 'Nicolás B.',
  location: 'Mar del Plata',
  time: 'hace 6 minutos'
}, {
  name: 'Romina C.',
  location: 'San Juan',
  time: 'hace 9 minutos'
}, {
  name: 'Matías L.',
  location: 'Entre Ríos',
  time: 'hace 2 minutos'
}, {
  name: 'Gabriela M.',
  location: 'Neuquén',
  time: 'hace 11 minutos'
}, {
  name: 'Andrés V.',
  location: 'Misiones',
  time: 'hace 3 minutos'
}, {
  name: 'Carolina F.',
  location: 'Jujuy',
  time: 'hace 6 minutos'
}, {
  name: 'Facundo R.',
  location: 'Chaco',
  time: 'hace 4 minutos'
}, {
  name: 'Natalia D.',
  location: 'Santa Fe',
  time: 'hace 8 minutos'
}, {
  name: 'Ezequiel P.',
  location: 'Corrientes',
  time: 'hace 5 minutos'
}, {
  name: 'Jimena H.',
  location: 'San Luis',
  time: 'hace 2 minutos'
}, {
  name: 'Tomás W.',
  location: 'Río Negro',
  time: 'hace 7 minutos'
}, {
  name: 'Agustina K.',
  location: 'Catamarca',
  time: 'hace 3 minutos'
}, {
  name: 'Leandro O.',
  location: 'La Rioja',
  time: 'hace 10 minutos'
}];
export function SocialProofPopup() {
  const [visible, setVisible] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [dismissed, setDismissed] = useState(false);
  const showNotification = useCallback(() => {
    setDismissed(false);
    setVisible(true);
  }, []);
  const hideNotification = useCallback(() => {
    setVisible(false);
  }, []);
  const handleClose = useCallback(() => {
    setDismissed(true);
    setVisible(false);
  }, []);
  // Initial appearance after 4 seconds
  useEffect(() => {
    const initialTimer = setTimeout(() => {
      showNotification();
    }, 4000);
    return () => clearTimeout(initialTimer);
  }, [showNotification]);
  // Auto-hide after 5 seconds when visible
  useEffect(() => {
    if (!visible) return;
    const hideTimer = setTimeout(() => {
      hideNotification();
    }, 5000);
    return () => clearTimeout(hideTimer);
  }, [visible, hideNotification]);
  // Cycle to next buyer every 12 seconds (after hide)
  useEffect(() => {
    if (visible || dismissed) return;
    const cycleTimer = setTimeout(() => {
      setCurrentIndex(prev => (prev + 1) % buyers.length);
      showNotification();
    }, 12000);
    return () => clearTimeout(cycleTimer);
  }, [visible, dismissed, showNotification]);
  const buyer = buyers[currentIndex];
  return <AnimatePresence data-id="element-315">
      {visible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 30
    }} className="fixed bottom-4 left-4 z-[9999] max-w-[290px] rounded-lg shadow-lg" style={{
      backgroundColor: '#111111',
      borderLeft: '3px solid #F5A623'
    }} data-id="element-316">
          <div className="relative p-4 pr-8" data-id="element-317">
            {/* Close button */}
            <button onClick={handleClose} className="absolute top-2 right-2 text-gray-500 hover:text-white transition-colors" aria-label="Cerrar notificación" data-id="element-318">
              <XIcon className="w-4 h-4" data-id="element-319" />
            </button>

            {/* Verified badge */}
            <div className="flex items-center gap-1.5 mb-1.5" data-id="element-320">
              <span className="relative flex h-2 w-2" data-id="element-321">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-green-400 opacity-75" data-id="element-322" />
                <span className="relative inline-flex rounded-full h-2 w-2 bg-green-500" data-id="element-323" />
              </span>
              <span className="text-[10px] font-bold uppercase tracking-wider" style={{
            color: '#22c55e'
          }} data-id="element-324">
                Compra verificada
              </span>
            </div>

            {/* Buyer name */}
            <p className="text-sm font-bold text-white leading-tight" data-id="element-325">
              {buyer.name} de {buyer.location}
            </p>

            {/* Product */}
            <p className="text-sm text-white leading-tight mt-0.5" data-id="element-326">
              compró{' '}
              <span className="font-bold" style={{
            color: '#F5A623'
          }} data-id="element-327">
                Megapack Contador Pro
              </span>
            </p>

            {/* Time */}
            <p className="text-[11px] mt-1.5" style={{
          color: '#9ca3af'
        }} data-id="element-328">
              {buyer.time}
            </p>
          </div>
        </motion.div>}
    </AnimatePresence>;
}